"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _listModule = _interopRequireDefault(require("./list.module.css"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = function List(props) {
  var id = props.id,
      items = props.items;
  return _react.default.createElement("ul", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, _listModule.default["my-list"])
  }, items.map(function (item, index) {
    return _react.default.createElement("li", {
      id: id ? "".concat(id, "_item_").concat(index) : null,
      key: index,
      className: item.className ? item.className : null
    }, item.content);
  }));
};

List.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    content: _propTypes.default.any,
    className: _propTypes.default.string
  })).isRequired
};
var _default = List;
exports.default = _default;